// Anonymous tallies: one "visit" per browser per day and one "match" per match started.
// The server adds the country from its own lookup table and keeps only daily totals.
type Kind = 'visit' | 'match';

function send(kind: Kind): void {
  try {
    void fetch('/api/ping', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ kind }),
      keepalive: true,
    }).catch(() => {});
  } catch {
    /* counting is best-effort */
  }
}

export function countVisit(): void {
  const today = new Date().toISOString().slice(0, 10);
  try {
    if (localStorage.getItem('qoobd-counted') === today) return;
    localStorage.setItem('qoobd-counted', today);
  } catch {
    /* no storage: count this page load */
  }
  send('visit');
}

export const countMatch = (): void => send('match');
